import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, ListResponse } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { BotLicense } from './licenses.abstraction';

@Injectable({ providedIn: 'root' })
export class LicensesApiService extends ApiService {
  isLoading$ = this._isLoading$;

  getLicenses(): Observable<ListResponse<BotLicense>> {
    return this._httpClient.get<ListResponse<BotLicense>>('@api/settings/bots/license/').pipe(
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }
}
